export const hasMailIntegrationFunctionality = (functionalities) => {
	return functionalities.some((func) => {
		if (func.functionality.customCode === 'MAIL_INTEGRATION') {
			return true;
		}
	});
};
